// src/sections/Section5.jsx
import React, { useState, useEffect } from "react";
import CardService from "../components/CardService";

// Swiper core + modules
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, A11y } from "swiper/modules";

// Swiper styles
import "swiper/css";
import "swiper/css/navigation";

const Section5 = ({ contenuti, cards }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

  // Imposta la prima immagine all’avvio
  useEffect(() => {
    if (cards && cards.length > 0) {
      setSelectedImage(cards[0].immagine);
    }
  }, [cards]);

  // Listener per breakpoint <→> desktop
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 992);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Helper per decidere link iOS vs Android/Desktop
  const getStoreLink = (rawLink) => {
    let iosLink = rawLink;
    let androidLink = rawLink;

    if (rawLink.includes("|")) {
      const [first, second] = rawLink.split("|");
      iosLink = first.trim();
      androidLink = second.trim();
    }

    const ua = navigator.userAgent || "";
    const isIOS =
      /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
    // Android + Desktop usano il secondo
    return isIOS ? iosLink : androidLink;
  };

  return (
    <>
      {contenuti.map((content, idx) => {
        const { titolo1, titolo2, sottotitolo } = content;

        return (
          <div key={idx} className="container-fluid py-4">
            {/* --- Header --- */}
            <div className="container text-center mb-4">
              {sottotitolo && <p className="mini-title">{sottotitolo}</p>}
              <div className="title-section">
                <h2 className="black-text me-2">{titolo1}</h2>
                <h2 className="green-text">{titolo2}</h2>
              </div>
            </div>

            {/* --- Desktop: cards in riga + image preview --- */}
            <div className="container d-none d-lg-block">
              {selectedImage && (
                <div className="text-center mb-3">
                  <img
                    src={selectedImage}
                    alt="Preview"
                    className="img-fluid"
                    style={{width:'100%'}}
                  />
                </div>
              )}
              <div className="row gx-2">
                {cards.map((card, i) => {
                  const href = getStoreLink(card.link);
                  return (
                    <div key={i} className="col-12 col-md-2 mb-2">
                      <a
                        href={href}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <CardService
                          imgSrc={card.immagineCard}
                          hoverImg={card.immagineCardHover}
                          text={card.titolo}
                          onMouseEnter={() => setSelectedImage(card.immagine)}
                          onFocus={() => setSelectedImage(card.immagine)}
                        />
                      </a>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* --- Mobile: Swiper --- */}
            <div id="black-swiper" className="container d-lg-none">
              <Swiper
                modules={[Navigation, A11y]}
                spaceBetween={16}
                slidesPerView={isMobile ? 1 : 2}
                navigation
                a11y={{ enabled: false }}
                style={{ padding: "1rem 0" }}
              >
                {cards.map((card, i) => {
                  const href = getStoreLink(card.link);
                  return (
                    <SwiperSlide key={i}>
                      <div className="d-flex justify-content-center flex-column">
                        <img
                          src={card.immagine}
                          alt={card.titolo}
                          className="img-fluid"
                          style={{ objectFit: "contain" }}
                        />
                        <div className="d-flex justify-content-center">
                          <a
                            href={href}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <div className="btn btn-dark-primary mt-4 d-inline-block py-3 border-radius-48">
                              {card.titolo}
                            </div>
                          </a>
                        </div>
                      </div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default Section5;
